var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXingLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "96px",
    height: "96px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.337 14l3.159 5.054L13.284 28h-2.061l4.368-7.488.913-1.565-.96-1.537L13.413 14H15.337M15.892 11h-5.65c-.976 0-1.571 1.074-1.054 1.901L13 19l-5.812 9.963C6.661 29.866 7.313 31 8.358 31h5.501c.712 0 1.37-.378 1.728-.993l5.805-9.964c.374-.642.361-1.437-.032-2.067l-3.773-6.036C17.222 11.355 16.581 11 15.892 11L15.892 11zM36.968 7L26.367 26.571l-.787 1.453.808 1.442L32.849 41h-2.097l-7.343-13.01L34.786 7H36.968M39.551 4h-5.36c-.734 0-1.409.402-1.758 1.047l-11.925 22c-.328.605-.322 1.337.017 1.936l7.902 14C28.781 43.611 29.446 44 30.168 44h5.477c1.04 0 1.696-1.12 1.188-2.027L29.005 28 40.836 6.158C41.363 5.184 40.658 4 39.551 4L39.551 4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXingLogo);
export default __webpack_public_path__ + "static/media/xingLogo.5383fd61016a369356675d6fd2d24ded.svg";
export { ForwardRef as ReactComponent };